import { dispatch } from "hf-rt";
import { HOST_URL } from "../constants";
import { errorPage, loading, addresses } from "../models";
import { setGAEvent } from "../function/setGAEvent";

const initialState = {
  getMyBagSuccessfully: false,
  myBagData: {
    cartItems: [],
    coupons: []
  }
};

let timer;

export default {
  name: "myBag",
  actions: {
    updateMyBag: payload => dispatch({ type: "UPDATE_MYBAG", payload }),
    fetchMyBag: async function () {
      dispatch({ type: "FETCH_MYBAG" });
      try {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/compositions/mybags`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
        if (response.ok) {
          const data = await response.json();
          this.updateMyBag(data);
          clearTimeout(timer);
          timer = setTimeout(() => {
            loading.actions.startLoading(false);
          }, 2000);
        } else {
          // Status Code 500 顯示錯誤頁面元件
          await errorPage.actions.showErrorPage(true);
          throw new Error("fetch-myBag-failed");
        }
      } catch (err) {
        console.log(err);
        clearTimeout(timer);
        timer = setTimeout(() => {
          loading.actions.startLoading(false);
        }, 2000);
      } finally {
        if (window.isLogin) {
          addresses.actions.fetchAddresses();
        }
      }
    },
    removeMyBagItem: async function (item, myBagData) {
      const { itemId } = item;
      loading.actions.startLoading(true);
      dispatch({ type: "REMOVE_MYBAG_ITEM" });
      //先發送API刪除此單筆商品
      // await req.delete({
      //   api: "removeMyBagItem",
      //   params: cartId
      // });
      await fetch(`${HOST_URL}/shopping/v1/cartItems/${itemId}`, {
        credentials: "include",
        method: "DELETE",
        headers: {
          "content-type": "application/json"
        }
      }).finally(() => {
        // 再重新fetchMyBag 取得最新的myBag
        this.fetchMyBag();
      });

      // GA Event
      const { code, prodname1, origPrice } = item.information;
      const firstDashIndex = code.indexOf("-");
      const usage = code.substring(firstDashIndex - 1, firstDashIndex);
      const params1 = {
        code: code,
        productName1: prodname1,
        usage: usage,
        categories: []
      };
      const params2 = {
        origPrice: origPrice,
        discountPrice: item.discountAmount,
        quantity: item.quantity
      };
      setGAEvent("remove_from_cart", params1, params2);
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_MYBAG":
        return {
          ...state,
          getMyBagSuccessfully: true,
          myBagData: action.payload
        };
      default:
        return state;
    }
  }
};
